var map = {
	"./2023-09-12.json": "WisP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q9zR";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/q&a \.json$
// module id = q9zR
// module chunks = 3